module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-740.4de6dd40.png";